import React from "react";

const MapMessage = ({ text }) => {
  // Add validation to ensure text exists and can be split
  if (!text || typeof text !== "string") {
    return (
      <div style={{ borderRadius: "8px", overflow: "hidden", margin: "8px 0" }}>
        <div
          style={{
            width: "250px",
            height: "200px",
            backgroundColor: "#f0f0f0",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            color: "#000",
          }}
        >
          Invalid location data
        </div>
      </div>
    );
  }

  const coordinates = text.split(",");

  // Check if we have valid coordinates
  if (coordinates.length < 2) {
    return (
      <div style={{ borderRadius: "8px", overflow: "hidden", margin: "8px 0" }}>
        <div
          style={{
            width: "250px",
            height: "200px",
            backgroundColor: "#f0f0f0",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            color: "#000",
          }}
        >
          Invalid location format
        </div>
      </div>
    );
  }

  const [lat, lng] = coordinates;
  const mapSrc = `https://www.google.com/maps?q=${lat},${lng}&z=15&output=embed`;

  return (
    <div style={{ borderRadius: "8px", overflow: "hidden", margin: "8px 0" }}>
      <iframe
        title="Location Preview"
        width="250"
        height="200"
        frameBorder="0"
        style={{ border: 0 }}
        src={mapSrc}
        allowFullScreen
      />
    </div>
  );
};

export default MapMessage;
